import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Checkbox from '@mui/material/Checkbox';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

import { useState, useEffect } from "react";
import { Button } from "@mui/material";

import EposProductTableRow from "./EposProductTableRow"
import InventoryIcon from '@mui/icons-material/Inventory';

export default function AccordionSection({
    title,
    details,
    eposProducts,
    promotionLink,
    handleModelAlert,
    handleReload,
    bookerProducts
}) {
// console.log(  promotionLink)

    const [expanded, setExpanded] = useState(false);
    const [bgColour, setBgColour] = useState("#FFFFFF");
    const [checkedValue, setCheckedValue] = useState(false);

    useEffect(() => {

        setBgColour("#FFFFFF");
        setCheckedValue(false);
        setExpanded(false);

    }, [title]);

    const handleSelect = (bool) => {

        setCheckedValue(bool);
        if (!bool) {
            setBgColour("#FFFFFF")
        } else {
            setBgColour(`rgba(0, 255, 51, 0.3)`)
        }
    }
     const stringCompare = ()=>{
        // compareThe 
     }
    const getDifference = (arr1, arr2, key1, key2) => {
        return expanded && arr1?.filter(
        //   (item1) => !arr2?.some((item2) => { console.log(item1[key1].split(','), item2[key1].split(',') ) ; return JSON.stringify(item1[key1]).trim() ==JSON.stringify(item2[key2])?.trim()})
          (item1) => !arr2?.some((item2) => { 
            // console.log(item1[key1].split(','), item2[key1].split(',') ) ;
            let first = item1[key1].split(',')
            let second = item2[key1].split(',')
            
            // return  first.includes(second[0]||second[1]) || second.includes(first[0]||first[1])
            return first.includes(second[0]||second[1] || second[2]) || second.includes(first[0]||first[1]||first[2])
         })
        ).map(item=>item?.barcode ? item.barcode : 0);
      };

      let BookerProductBarCode = getDifference(eposProducts, bookerProducts, 'barcode', 'barcode')
    //   console.log(' epos one diference ', BookerProductBarCode)
    return (

        <Accordion
            defaultExpanded={false}
            expanded={expanded}
            className="accodion_main"
            style={{
                backgroundColor: bgColour
            }}
        >
            <AccordionSummary
                expandIcon={<KeyboardDoubleArrowDownIcon
                    //ExpandMoreIcon
                    onClick={() => setExpanded(!expanded)}
                    className="expand_icon"
                />}
                style={{
                    textAlign: "center",
                    justifyContent: "space-between"
                }}
                className="accordion_summary"
            >
                <div className='accordion_summary'>
                    <p>{`${title}    ${promotionLink != null ? `(${ eposProducts?.length})` : ''}` }</p>
                    <p></p>
                    <div className='accordion_summary_icons'>
                        {promotionLink != null ? (
                            <Button
                            size='small'
                                variant="contained"
                                color="primary"
                                href={promotionLink}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Epos Promotion
                            </Button>
                        ) :
                            <>
                                {/* success */}
                                {eposProducts != null ? (
                                    <InventoryIcon
                                        color={eposProducts.length != 1  || eposProducts == null
                                            ? "error" : "success"}
                                    />
                                ) : (
                                    <InventoryIcon
                                        color={"error"}
                                    />
                                )}
                                <Checkbox
                                    onChange={(e) => handleSelect(e.target.checked)}
                                    checked={checkedValue}
                                />

                            </>
                        }
                    </div>
                </div>
            </AccordionSummary>

                    <hr/>

            <AccordionDetails
                className="accordion_details_header"
            >
                {details.map(function (detail, i) {
                    return (
                        <p>{detail.name} : {detail.value} </p>
                    )
                })}
            </AccordionDetails>
            
            {eposProducts != null ? (
            <AccordionDetails>
                <table className="epos-prod-table">
                    <tr>
                        <th>Epos Product</th>
                        <th style={{width:'150px'}}>Barcode</th>
                        <th>Order Code</th>
                        <th>Category</th>
                        <th>Price</th>
                        <th>Epos Link</th>
                    </tr>

                    {eposProducts.map(function (product, i) {
                        let isExistInBooker = BookerProductBarCode
                        // let isExistInBooker = BookerProductBarCode?.includes(product.barcode)
                        return (
                            <EposProductTableRow
                                BookerProductBarCode={BookerProductBarCode}
                                product={product}
                                bookerBarcode={promotionLink != null ? details.filter((detail) => detail.name == "Barcode") : null}
                                handleModelAlert={handleModelAlert}
                                baseRRP={details.filter((detail) => detail.name == "RRP").pop()}
                            />
                        )
                    })}

                </table>
            </AccordionDetails>
            ) : (
                <p>NO LINKING EPOS PRODUCTS FOUND</p>
            ) }
        </Accordion>
    )


}